import "./LandingPage.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import upcomingEvents11 from "../../../Assets/Images/upcoming_events_11.png";
import upcomingEvents08 from "../../../Assets/Images/upcoming_events_08.png";
import upcomingEvents10 from "../../../Assets/Images/upcoming_events_10.png";
import upcomingEvents13 from "../../../Assets/Images/upcoming_events_13.png";
import upcomingEvents14 from "../../../Assets/Images/upcoming_events_14-wide.png";
import upcomingEvents15 from "../../../Assets/Images/upcoming_events_15-wide.png";
import upcomingEvents17 from "../../../Assets/Images/upcoming_events_17-card.png";

function LandingPage() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
    };

    const gridItems = [
        {
            title: "Grupo Niche at Hard Rock Live",
            description: "Niche Disco Tour — October 31 at 8 PM in Hollywood, FL.",
            image: upcomingEvents14,
        },
        {
            title: "House of Horror at Tropical Park",
            description: "25 Years of Fear — September 24 through November 1.",
            image: upcomingEvents15,
        },
        {
            title: "Christmas Wonderland at Tropical Park",
            description: "November 12 through January 3. Unlimited carnival rides and free parking for all ages.",
            image: upcomingEvents17,
        },
        {
            title: "Karol G at Hard Rock Stadium",
            description: "Experience Karol G's vibrant Latin energy at Hard Rock Stadium.",
            image: upcomingEvents13,
        },
        {
            title: "Miami Open Ritmo Social VIP",
            description: "Experience vibrant Latin culture at Miami Open",
            image: upcomingEvents11,
        },
        {
            title: "Miami Race Weekend at Hard Rock Stadium",
            description: "Aiming to bring Latin flavor to Miami's biggest race",
            image: upcomingEvents08,
        },
        {
            title: "Inter Miami CF Season 2026",
            description: "Inter Miami CF Season 2026",
            image: upcomingEvents10,
        },
    ];

    return (
        <div className="landing-page">
            <Slider {...settings} className="carousel">
                {gridItems.map((item, index) => (
                    <div key={index} className={`slide slide${index + 1}`}>
                        <div className="slide-content">
                            <h2>{item.title}</h2>
                            <p>{item.description}</p>
                        </div>
                    </div>
                ))}
            </Slider>
            <div className="grid-section">
                <h2>Upcoming Events</h2>
                <div className="landing-page-grid-container">
                    {gridItems.map((item, index) => (
                        <div key={index} className="grid-item">
                            <img src={item.image} alt={item.title} />
                            <div className="grid-item-content">
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LandingPage;
